module.exports = __webpack_public_path__ + "static/img/zhuhai.84f2879.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhuhai.png
// module id = Gs1Y
// module chunks = 19